export default {
  text: 'Verificar con {{provider}}',
  text_generic: 'Verificar con tu proveedor de pago',
  error: 'No pudimos abrir el formulario de {{provider}}. Inténtalo de nuevo.',
  error_generic: 'No pudimos abrir el formulario del proveedor de pago. Inténtalo de nuevo.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
